import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ObjectType } from "typescript";
import { useUser } from "../auth/UseUser";
import Avatar from "@mui/material/Avatar";
import {
  FaUserAlt,
  FaUserEdit,
  FaUserLock,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import { ReactComponent as Grb } from "../assets/svg/srbija-grb.svg";
import ConfirmationModal from "./modals/ConfirmationModal";
import {
  getAllParameterByName,
  lockEditingStatus,
  whoAmI,
} from "../server/server";
import { Tooltip } from "@mui/material";

function NavBar() {
  const location = useLocation();
  const { user, setUser } = useUser();
  let navigate = useNavigate();
  const [logOutModal, setLogOutModal] = useState(false);
  const [loc, setLoc] = useState("/");
  const [year, setYear] = useState("");
  const [roles, setRoles] = useState<any[]>([]);
  const [showRoleDropdown, setShowRoleDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [reportLocked, setReportLocked] = useState(false);

  const fetchCurrentStatusData = async () => {
    const response = await lockEditingStatus();
    if (response.status === 200) setReportLocked(response.data.isActive);
  };

  const fetchUserRoles = async () => {
    const resp = await whoAmI();

    if (resp.status === 200) {
      setRoles(resp.data.roles);
    }
  };

  const handleRolePick = async (role: any) => {
    setUser({ ...user, roleView: role });
    await localStorage.setItem(
      "user",
      JSON.stringify({ ...user, roleView: role }),
    );
    setShowRoleDropdown(false);
  };

  useEffect(() => {
    const pathList = location.pathname.split("/");
    setLoc("/" + pathList[1]);

    getAllParameterByName("menu-year").then((response: any) => {});
    fetchCurrentStatusData();
    fetchUserRoles();
  }, [location.pathname]);
  const closeLogOutModal = () => {
    setLogOutModal(false);
  };
  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    setUser({});
  };

  const disabled =
    !user?.roleView?.features?.includes("administration") && reportLocked;

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowRoleDropdown(false);
      }
    }
    if (showRoleDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showRoleDropdown]);
  const viewMap = {
    administration: (
      <p
        key={"administration"}
        className={` hover:bg-darkBlue cursor-pointer px-2 py-1 text-center hover:text-white ${
          loc === "/administration" ? "bg-darkBlue text-white" : ""
        }
        `}
        onClick={() => (!disabled ? navigate("/administration") : null)}
      >
        Администрирање
      </p>
    ),
    register: (
      <Tooltip
        key={"register"}
        title={
          disabled
            ? "Период планирања је завршен, у Прегледима можете прегледати прописе и мере."
            : ""
        }
        arrow
        disableHoverListener={!disabled}
      >
        <p
          className={`px-2 py-1 text-center ${
            disabled
              ? "text-gray-400 cursor-not-allowed opacity-50"
              : `hover:bg-darkBlue cursor-pointer hover:text-white ${
                  loc === "/register" ? "bg-darkBlue text-white" : ""
                }`
          }`}
          onClick={() => !disabled && navigate("/register")}
        >
          Планирање
        </p>
      </Tooltip>
    ),
    measure: (
      <p
        key={"measure"}
        className={` hover:bg-darkBlue cursor-pointer px-2 py-1 text-center hover:text-white ${
          loc === "/measure" ? "bg-darkBlue text-white" : ""
        }
        `}
        onClick={() => navigate("/measure")}
      >
        Мерила
      </p>
    ),
    reporting: (
      <p
        key={"reporting"}
        className={` hover:bg-darkBlue cursor-pointer px-2 py-1 text-center hover:text-white ${
          loc === "/reporting" ? "bg-darkBlue text-white" : ""
        }
        `}
        onClick={() => navigate("/reporting")}
      >
        Извештавање
      </p>
    ),
    views: (
      <p
        key={"views"}
        className={` hover:bg-darkBlue cursor-pointer px-2 py-1 text-center hover:text-white ${
          loc === "/views" ? "bg-darkBlue text-white" : ""
        }
        `}
        onClick={() => navigate("/views")}
      >
        Прегледи
      </p>
    ),

    jurisdiction: (
      <p
        key={"jurisdiction"}
        className={` hover:bg-darkBlue cursor-pointer px-2 py-1 text-center hover:text-white ${
          loc === "/jurisdiction" ? "bg-darkBlue text-white" : ""
        }
        `}
        onClick={() => navigate("/jurisdiction")}
      >
        Надлежности
      </p>
    ),
  };
  const shorteMAP = {
    Администратор: "Админ",
    Координатор: "Коор.",
    "Уносилац података": "УП",
    "Секретар преговарачке групе": "СП",
  };
  return (
    <div className="w-full bg-[#0F2765]">
      <div className="w-full h-[85px] flex justify-between items-center p-1 px-[60px] bg-[#0F2765] text-white ">
        <div
          className="flex items-center text-white"
          style={{ transform: "scale(0.9)" }}
        >
          <Grb style={{ height: 75, width: 40 }} />
          <div className="flex flex-col justify-between my-2 ml-3">
            <span className="font-medium text-sm">Република Србија</span>
            <span className="text-lg leading-5 mt-1">
              Министарство за <br /> европске интеграције
            </span>
          </div>
        </div>

        <div className="flex h-full items-end">
          <h2 className="text-xl font-semibold">
            Национални програм за усвајање правних тековина ЕУ {year}
          </h2>
        </div>
        <div className="flex flex-col items-end justify-between h-[68px]">
          <div
            className="hover:opacity-60 cursor-pointer"
            onClick={() => setLogOutModal(true)}
          >
            <p className="text-lg">Одјави се</p>
          </div>
          <div
            className="relative"
            onClick={() => setShowRoleDropdown(!showRoleDropdown)}
            ref={dropdownRef}
          >
            <p className="text-lg hover:opacity-60 cursor-pointer underline">
              {!!user
                ? `${
                    shorteMAP[user?.roleView?.name as keyof typeof shorteMAP] ??
                    ""
                  } ${user?.institution?.abbreviation ?? ""} ${
                    user?.firstName ?? ""
                  } ${user?.lastName ?? ""}`
                : ""}
            </p>
            {showRoleDropdown && (
              <div
                className="absolute top-10 w-full bg-white text-black rounded shadow-md z-10"
                onMouseLeave={() => setShowRoleDropdown(false)}
              >
                {roles &&
                  roles.map((r) => (
                    <div
                      key={r.name}
                      className="flex items-center gap-2 px-3 py-2 hover:bg-[#0563c1] cursor-pointer"
                      onClick={() => handleRolePick(r)}
                    >
                      {(() => {
                        const ROLE_ICON_MAP = {
                          Администратор: <FaUserTie className="w-5 h-5" />,
                          Координатор: <FaUserAlt className="w-5 h-5" />,
                          "Уносилац података": (
                            <FaUserEdit className="w-5 h-5" />
                          ),
                          "Секретар преговарачке групе": (
                            <FaUsers className="w-5 h-5" />
                          ),
                          "Одговорна особа": <FaUserLock className="w-5 h-5" />,
                        };
                        return (
                          ROLE_ICON_MAP[
                            r.name as keyof typeof ROLE_ICON_MAP
                          ] ?? <FaUserAlt className="w-5 h-5" />
                        );
                      })()}
                      <span>{r.name}</span>
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="min-h-[32px] bg-[#F6F6F6] px-16 flex items-center gap-y-1 sm:gap-x-10 xl:gap-x-20  gap-x-5 pt-[2px] flex-wrap">
        {[
          "administration",
          "measure",
          "register",
          "reporting",
          "views",
          "jurisdiction",
          "help",
        ].map((view: string) => {
          if (user?.roleView?.features?.includes(view)) {
            return viewMap[view as keyof typeof viewMap];
          } else {
          }
        })}
      </div>
      <ConfirmationModal
        modalIsOpen={logOutModal}
        closeModal={closeLogOutModal}
        confirmation={logout}
        message={`Одјави се`}
      />
    </div>
  );
}

export default NavBar;
